<po-page-list
  #poPageList
  [p-actions]="pageActions"
  [p-filter]="filter"
  [p-quick-search-value]="filters.search"
  [p-disclaimer-group]="disclaimerGroup">

  <po-tabs>
    <po-tab
      *ngFor="let tab of statusTabs"
      [p-label]="tabLabel(tab)"
      [p-active]="activeStatus === tab.value"
      (p-click)="selectTab(tab.value)">
    </po-tab>
  </po-tabs>

  <app-period-filter
    [period]="period"
    (periodChange)="onPeriodChange($event)">
  </app-period-filter>

  <po-table
    class="curation-queue-table"
    [class.curation-queue-table--curated]="!isPending"
    (p-change-visible-columns)="onColumnsChange($event)"
    (p-restore-column-manager)="onColumnsRestore()"
    [p-columns]="columns"
    [p-items]="items"
    [p-actions]="tableActions"
    p-actions-right="true"
    p-striped="true"
    p-sort="true"
    p-spacing="small"
    [p-loading]="loading"
    [p-show-more-disabled]="allLoaded"
    [p-loading-show-more]="loadingShowMore"
    (p-sort-by)="onSortBy($event)"
    (p-show-more)="onShowMore()">

    <ng-template p-table-cell-template let-column="column" let-row="row">
      <ng-container *ngIf="column.property === 'resourceType'">
        <po-tag
          [p-value]="row.resourceTypeLabel"
          p-color="#753399"
          p-inverse="true">
        </po-tag>
      </ng-container>

      <ng-container *ngIf="column.property === 'displayName'">
        <div class="curation-label-cell">
          <div class="curation-label-text">
            <span class="curation-primary-label">{{ row.displayName }}</span>
            <span class="curation-secondary-label" *ngIf="row.description">
              {{ row.description }}
            </span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="column.property === 'source'">
        <span
          *ngIf="row.source"
          class="curation-source-cell"
          [title]="row.filePath || row.source">
          {{ row.source }}
        </span>
      </ng-container>

      <ng-container *ngIf="column.property === 'status'">
        <div class="curation-status-cell">
          <po-tag
            [p-value]="getStatusLabel(row.status)"
            [p-type]="getStatusBadgeType(row.status)"
            p-inverse="true">
          </po-tag>
        </div>
      </ng-container>

      <ng-container *ngIf="column.property === 'findingKind'">
        <po-tag
          [p-value]="row.findingKindLabel"
          p-color="#0c9abe"
          p-inverse="true">
        </po-tag>
      </ng-container>

      <ng-container *ngIf="column.property === 'info'">
        <span class="po-icon po-icon-info curation-info-icon"
          [p-tooltip]="row.tooltip"
          p-tooltip-position="top">
        </span>
      </ng-container>

      <ng-container *ngIf="column.property === 'feedbackUsers'">
        <po-tag
          *ngIf="row.feedbackUsers?.length"
          [p-value]="row.feedbackUsersLabel"
          [p-tooltip]="row.feedbackUsers.join(', ')"
          p-inverse="true">
        </po-tag>
      </ng-container>

      <ng-container *ngIf="column.property === 'votes'">
        <span class="curation-votes-cell">
          <span class="curation-vote curation-vote--tp" [class.curation-vote--active]="(row.votes?.truePositive ?? 0) > 0"
            [p-tooltip]="voteTooltips.truePositive" p-tooltip-position="top">{{ row.votes?.truePositive ?? 0 }} TP</span>
          <span class="curation-vote curation-vote--fp" [class.curation-vote--active]="(row.votes?.falsePositive ?? 0) > 0"
            [p-tooltip]="voteTooltips.falsePositive" p-tooltip-position="top">{{ row.votes?.falsePositive ?? 0 }} FP</span>
          <span class="curation-vote curation-vote--wf" [class.curation-vote--active]="(row.votes?.wontFix ?? 0) > 0"
            [p-tooltip]="voteTooltips.wontFix" p-tooltip-position="top">{{ row.votes?.wontFix ?? 0 }} WF</span>
        </span>
      </ng-container>
    </ng-template>
  </po-table>

</po-page-list>

<!-- Modal de busca avançada -->
<po-modal
  #advancedFilterModal
  p-title="Busca Avançada"
  p-size="md"
  [p-primary-action]="advancedFilterApplyAction"
  [p-secondary-action]="advancedFilterCancelAction"
  p-click-out="false">

  <po-divider p-label="Classificação"></po-divider>
  <div class="po-row">
    <po-multiselect
      class="po-md-6"
      name="advKind"
      p-label="Tipo de achado"
      p-placeholder="Todos"
      p-filter-mode="contains"
      [p-options]="kindOptions"
      [(ngModel)]="advancedFilters.kind">
    </po-multiselect>
    <po-multiselect
      class="po-md-6"
      name="advFindingKind"
      p-label="Tipo de item"
      p-placeholder="Todos"
      p-filter-mode="contains"
      [p-options]="findingKindOptions"
      [(ngModel)]="advancedFilters.findingKind">
    </po-multiselect>
  </div>
  <div class="po-row" *ngIf="isPending">
    <po-multiselect
      class="po-md-6"
      name="advResolution"
      p-label="Resolução"
      p-placeholder="Todas"
      p-filter-mode="contains"
      [p-options]="resolutionOptions"
      [(ngModel)]="advancedFilters.resolution">
    </po-multiselect>
  </div>

  <po-divider p-label="Código"></po-divider>
  <div class="po-row">
    <po-multiselect
      class="po-md-6"
      name="advResourceType"
      p-label="Tipo de review"
      p-placeholder="Todos"
      p-filter-mode="contains"
      [p-options]="resourceTypeOptions"
      [(ngModel)]="advancedFilters.resourceType">
    </po-multiselect>
    <po-input
      class="po-md-6"
      name="advResourceId"
      p-label="Código"
      p-placeholder="ex: 43307, PROJ-123"
      p-clean
      [(ngModel)]="advancedFilters.resourceId">
    </po-input>
    <po-multiselect
      class="po-md-6"
      name="advProvider"
      p-label="Origem"
      p-placeholder="Todas as origens"
      p-filter-mode="contains"
      [p-options]="sourceProviderOptions"
      [(ngModel)]="advancedFilters.sourceProvider">
    </po-multiselect>
    <po-multiselect
      class="po-md-6"
      name="advLanguage"
      p-label="Linguagem"
      p-placeholder="Todas"
      p-filter-mode="contains"
      [p-options]="languageOptions"
      [(ngModel)]="advancedFilters.language">
    </po-multiselect>
  </div>

  <ng-container *ngIf="isCurationTab">
    <po-divider p-label="Curadoria"></po-divider>
    <div class="po-row">
      <po-multiselect
        class="po-md-6"
        name="advCategory"
        p-label="Categoria"
        p-placeholder="Todas"
        p-filter-mode="contains"
        [p-options]="categoryOptions"
        [(ngModel)]="advancedFilters.category">
      </po-multiselect>
      <po-multiselect
        class="po-md-6"
        name="advLever"
        p-label="Alavanca de melhoria (lever)"
        p-placeholder="Todas"
        p-filter-mode="contains"
        [p-options]="leverOptions"
        [(ngModel)]="advancedFilters.lever">
      </po-multiselect>
      <po-input
        class="po-md-6"
        name="advCuratedBy"
        p-label="Curado por"
        p-placeholder="ex: anderson.jose"
        p-clean
        [(ngModel)]="advancedFilters.curatedBy">
      </po-input>
    </div>
  </ng-container>

  <po-divider p-label="Dev"></po-divider>
  <div class="po-row">
    <po-input
      class="po-md-6"
      name="advFeedbackUser"
      p-label="Avaliado por"
      p-placeholder="ex: maria.silva"
      p-clean
      [(ngModel)]="advancedFilters.feedbackUser">
    </po-input>
  </div>

</po-modal>

<app-curation-modal (curated)="onCurated($event)" (discarded)="onDiscardedFromModal($event)"></app-curation-modal>

<notificationComponentHM></notificationComponentHM>
